import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navigationLinks = [
    { name: 'Inicio', path: '/' },
    { name: 'Nosotros', path: '/nosotros' },
    { name: 'Servicios', path: '/servicios' },
    { name: 'Whitepaper 4.0', path: '/whitepaper' },
    { name: 'Gobierno Corporativo', path: '/gobierno-corporativo' },
    { name: 'Servicio de PLD', path: '/pld' },
    { name: 'ISO', path: '/iso' },
    { name: 'Nuestro equipo', path: '/equipo' },
    { name: 'Noticias', path: '/noticias' },
    { name: 'Blog', path: '/blog' },
  ];

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          {/* Logos */}
          <Link to="/" className="flex items-center gap-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_public-notary-lab/artifacts/4wfopplb_LOGO%20PNG%20_Mesa%20de%20trabajo%201.png" 
              alt="Notaria 90" 
              className="h-14 w-auto"
            />
            <div className="h-10 w-px bg-gray-300"></div>
            <img 
              src="https://customer-assets.emergentagent.com/job_public-notary-lab/artifacts/dicik570_ISOTIPO%20COLOR%20HICTH.png" 
              alt="Hitch" 
              className="h-10 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-6">
            {navigationLinks.map((link, index) => (
              <Link
                key={index}
                to={link.path}
                className={`text-sm font-medium transition-colors duration-300 ${
                  isActive(link.path)
                    ? 'text-notaria-secondary border-b-2 border-notaria-secondary pb-1'
                    : 'text-gray-700 hover:text-notaria-secondary'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </nav>

          {/* Auth section removed from web — auth is mobile-app only.
              Keeping the backend endpoints intact for the iOS/Android app. */}
          <div className="hidden lg:flex items-center space-x-4" />

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-gray-700"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4">
            <nav className="flex flex-col space-y-4">
              {[...navigationLinks, { name: 'Contáctanos', path: '/contacto' }].map((link, index) => (
                <Link
                  key={index}
                  to={link.path}
                  onClick={() => setMobileMenuOpen(false)}
                  className={`text-left transition-colors duration-300 ${
                    isActive(link.path)
                      ? 'text-notaria-secondary font-semibold'
                      : 'text-gray-700 hover:text-notaria-secondary'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
